import React from 'react';

import { Table, TableContainer } from '@mui/material';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';

import { IPreInscription } from '../../../../types/pre-inscription.type';
import PreInscriptionListBody from '../PreInscriptionListBody';
import PreInscriptionListHead from '../PreInscriptionListHead';

interface IProps {
  inscriptions: IPreInscription[];
}

const PreInscriptionList = React.memo(({ inscriptions }: IProps) => (
  <Grid container mt={3}>
    <Grid item xs={12}>
      <TableContainer component={Paper} sx={{ maxHeight: '80vh' }}>
        <Table stickyHeader aria-label="sticky table">
          <PreInscriptionListHead />
          <PreInscriptionListBody inscriptions={inscriptions} />
        </Table>
      </TableContainer>
    </Grid>
  </Grid>
));

export default PreInscriptionList;
